import { render } from "./EmptyLayout.vue?vue&type=template&id=11683200"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__